window.addEventListener("scroll", function() {
  if (window.innerWidth >= 1200) {
    let topDistance = this.pageYOffset;
    let parallaxNodeList = document.querySelectorAll("[data-type='parallax']");

    for (let i = 0; i < parallaxNodeList.length; i++) {
      let parallaxNode = parallaxNodeList[i];
      let depth = parallaxNode.dataset.depth;
      let movement = -(topDistance * depth);
      let translateY = `translateY(${movement}px)`;

      parallaxNode.style["-webkit-transform"] = translateY;
      parallaxNode.style["-moz-transform"] = translateY;
      parallaxNode.style["-ms-transform"] = translateY;
      parallaxNode.style["-o-transform"] = translateY;
      parallaxNode.style.transform = translateY;
    }
  }
});
